// extracted by mini-css-extract-plugin
module.exports =  {"toast":"toast__ekdh1","action":"action__2xIJx","header":"header__QteoL","body":"body__gzQTV","close":"close__s4gxe","success":"success__a5otg","failure":"failure__aakBK"};